import React, { Component } from 'react';
import './Slider.css';

export default class Slider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value != null ? this.props.value : 50,
			min: this.props.min != null ? this.props.min : 1,
			max: this.props.max != null ? this.props.max : 100,
		};
	};

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.value != nextState.value) {
			this.setState({
				value: nextProps.value,
			})
		}
		return true;
	}

	handleOnChange = (event) => {
		this.setState({
			value: event.target.value,
		});
		this.props.handleChangeSliderVal(event.target.value)
	}

	render() {
		var style = {
			maxWidth: 340,
		};

		var verticalStyle = {
			transform: 'rotate(270deg)',
		}

		style = Object.assign(style, this.props.style);

		return (
			<div style={style} id='slider'>
				<div className="Cmp_slidecontainer">
					{this.props.isVertical ?
						<div style={{ position: 'absolute' }}>
							<input
								style={verticalStyle}
								onFocus={(event) => this.handleOnFocus(event)}
								type="range" min={this.state.min} max={this.state.max}
								value={this.state.value}
								className="Cmp_slider"
								id="myRange"
								onChange={(event) => this.handleOnChange(event)}
								onMouseDown={(event) => this.handleMouseDown(event)}
								onMouseUp={(event) => this.handleOnMouseUp(event)}
								onTouchStart={(event) => this.handleMouseDown(event)}
								onTouchEnd={(event) => this.handleOnMouseUp(event)}
								step={this.props.step}
							/>
						</div>
						: <input step={this.props.step} type="range" min={this.state.min} max={this.state.max} value={this.state.value} className="Cmp_slider" id="myRange" onChange={(event) => this.handleOnChange(event)} />
					}
				</div>
			</div>
		);
	}
}
